import axios, { AxiosResponse } from 'axios';
import * as utils from './apiUtils';
import type { MasterGetAllResponse } from '@/models/apis/master/masterResponse';

export default {
  getAll(): Promise<AxiosResponse<MasterGetAllResponse>> {
    return axios.get(utils.getApiUrl('/masters'));
  },
};
